module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mntrelm2-f82fad6345b7340b81a6faae26d59632.jpg";